'use strict';

/**
 * Model for an image in create process
 *
 * @category   Model
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var ImageModel = Model.extend({
    api: '/assets',

    defaults: {
        main: false,
        baseUrl: null,
        fileName: null,
        percentCompleted: 0,
        uploading: false,
    },

    /**
     * Returns the imageURL for the given size
     * @param {string} size The size to take
     * @returns {string} Path to the image
     */
    getImageUrl: function(size) {
        size = size || '640x640';

        var baseUrl = this.get('baseUrl');
        var fileName = this.get('fileName');

        if (baseUrl && fileName) {
            if (/\.svg$/.test(fileName)) {
                return baseUrl + fileName;
            }

            return baseUrl + size + '/' + fileName;
        }

        var placeholder = this.getPlaceholderImage();

        return placeholder.baseUrl + placeholder.fileName;
    },

    /**
     * Retruns the image
     * @returns {object} The path and filename object
     */
    getImage: function() {
        var baseUrl = this.get('baseUrl');
        var fileName = this.get('fileName');

        if (baseUrl && fileName) {
            return {
                baseUrl: baseUrl,
                fileName: fileName,
            };
        } else {
            return this.getPlaceholderImage();
        }
    },

    /**
     * Returns the URL of a placeholder image
     * @returns {object} The placeholder image
     */
    getPlaceholderImage: function() {
        if (!this._placeHolderImage) {
            var variant = Math.floor((Math.random() * 4) + 1);

            var catalog = App.CollectionModule.catalogs.getActiveCatalog();
            var catalogType = catalog.get('type');

            this._placeHolderImage = {
                baseUrl: '/images/placeholder/256x256/',
                fileName: 'item-placeholder-' + catalogType + '-' + variant + '.jpg',
                isPlaceholder: true,
            };
        }

        return this._placeHolderImage;
    },
});

module.exports = ImageModel;